import { useEffect, useState } from 'react';
import { isEqual } from 'lodash';
import { useAwmsStore } from '@/store/AwmsStore';
import { DataTable, FilterOption } from '@/components/Common';
import { useSchoolUnitData } from '@/hooks';
import { generateFilterOptions } from '@/lib/utils';
import { schoolUnitColumns } from './SchoolUnitColumns';
import { FILTERS } from '@/constants';

export const SchoolUnit = () => {
  const years = useAwmsStore((state) => state.getYears);
  const selectedSchoolId = useAwmsStore((state) => state.selectedSchoolId);
  const setSelectedSchoolId = useAwmsStore((state) => state.setSelectedSchoolId);
  const selectedStudyPeriodId = useAwmsStore((state) => state.selectedStudyPeriodId);
  const setSelectedStudyPeriodId = useAwmsStore((state) => state.setSelectedStudyPeriodId);
  const activeYear = useAwmsStore((state) => state.activeYear);
  const setActiveYear = useAwmsStore((state) => state.setActiveYear);
  const [filterOptions, setFilterOptions] = useState<FilterOption[]>([]);
  const { schoolList, studyPeriodList, schoolUnitDetails, isPageLoading } = useSchoolUnitData();

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  useEffect(() => {
    const yearOptions = years();
    if (!schoolList || !studyPeriodList) return;

    const newFilters = [
      {
        placeholder: 'Select school',
        checkbox: false,
        options: generateFilterOptions(schoolList),
        stateFilterFieldName: FILTERS.SCHOOL,
        selectedState: selectedSchoolId,
        setSelectedState: setSelectedSchoolId,
      },
      {
        placeholder: 'Select study period',
        checkbox: false,
        options: generateFilterOptions(studyPeriodList, 'withAll'),
        stateFilterFieldName: FILTERS.STUDYPERIOD,
        selectedState: selectedStudyPeriodId,
        setSelectedState: setSelectedStudyPeriodId,
        className: 'w-[220px] 2xl:w-[360px]',
      },
      {
        placeholder: 'Select year',
        checkbox: false,
        options: yearOptions.map((year) => {
          return {
            label: year,
            value: parseInt(year),
          };
        }),
        stateFilterFieldName: FILTERS.YEAR,
        selectedState: activeYear,
        setSelectedState: setActiveYear,
        className: 'w-[125px]',
      },
    ];

    // Only update state if newFilters is different from the current state
    if (!isEqual(filterOptions, newFilters)) {
      setFilterOptions(newFilters);
    }
  }, [
    activeYear,
    filterOptions,
    schoolList,
    selectedSchoolId,
    selectedStudyPeriodId,
    setActiveYear,
    setSelectedSchoolId,
    setSelectedStudyPeriodId,
    studyPeriodList,
    years,
  ]);

  return (
    <div className="flex h-full w-screen flex-col items-start overflow-auto py-0">
      <div className="w-screen">
        <DataTable
          id="SchoolUnitTable"
          hasGlobalFilterHeader
          columns={schoolUnitColumns}
          data={schoolUnitDetails?.length ? schoolUnitDetails : []}
          tableProps={{ padding: 'px-8' }}
          globalFilterHeaderProps={{
            searchColumn: { searchPlaceHolder: 'Search unit by id or name', columnId: 'unitId' },
            filterOptions: filterOptions,
          }}
          headerProps={{ primaryColor: 'bg-white', borderColor: 'border-secondary-grey-04' }}
          isPageLoading={isPageLoading}
          pagination={pagination}
          setPagination={setPagination}
          defaultSort={{ id: 'unitId' }}
        />
      </div>
    </div>
  );
};
